import { z } from 'zod';
import { ComponentType } from '$lib/sanity/types';
import { SanityDocumentSchema } from '../sanity';
import { TextBlockSchema } from './Text';

export const QuoteSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Quote),
  copy: z.array(TextBlockSchema),
  authorInfo: z
    .object({
      name: z.array(TextBlockSchema),
      title: z.array(TextBlockSchema).optional().nullable()
    })
    .optional()
    .nullable()
});

export type Quote = z.infer<typeof QuoteSchema>;
